const defaultThClass = 'font-[500] text-[#333] !text-[14px] !capitalize !px-[16px] !py-[12px]'
const defaultTdClass = 'text-[#333] !text-[14px] !px-[16px] !py-[12px]'

export const BahanPackingConfirmedFields = [
  {
    key: 'name',
    label: 'Bahan Packing',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'price',
    label: 'Harga',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'id',
    label: 'Action',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
]

export const BahanPackingPengajuanFields = [
  {
    key: 'name',
    label: 'Bahan Packing',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'price',
    label: 'Harga',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'status',
    label: 'Status',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'id',
    label: 'Action',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
]

export const PengajuanBahanPackingStatus = {
  1: {
    label: 'Ditinjau',
    css: 'bg-[#FFF2E2] text-[#AF6A13] border-[#FBA63C]',
  },
  2: {
    label: 'Diterima',
    css: 'bg-[#BEFCDE] text-[#34A770] border-[#34A770]',
  },
  3: {
    label: 'Ditolak',
    css: 'bg-[#FFEDED] text-[#E31A1A] border-[#E31A1A]',
  },
}

export const allowedImageExtensions = ['jpeg', 'jpg', 'png', 'svg']
export const allowedImageSize = 1000000

export const ChargeType = {
  1: 'Qty',
  2: 'm²',
}
